import { faTimesCircle } from '@fortawesome/pro-duotone-svg-icons'
import customConfig from 'customConfig'
import { memo } from 'react'

import { COLOR_ERROR } from '../../../constants/theme'
import FailedStatus from '../common/FailedStatus'

const CodeNotExist = ({ onSubmit, t }) => (
  <FailedStatus
    title={t('reward.wrong-code')}
    description={t(customConfig.incorrectRewardCodeLabel)}
    icon={faTimesCircle}
    color={COLOR_ERROR}
    onSubmit={onSubmit}
    t={t}
  />
)

export default memo(CodeNotExist)
